import { CREDIT_SCORES } from '@ratehub/documents/common/stable';


export default CREDIT_SCORES;
